const map = {
	"./WhatsApp Image 2025-01-17 at 11.44.08 PM.jpeg": 4749,
	"./WhatsApp Image 2025-01-17 at 11.44.09 PM (1).jpeg": 7530,
	"./WhatsApp Image 2025-01-17 at 11.44.09 PM (2).jpeg": 8645,
	"./WhatsApp Image 2025-01-17 at 11.44.09 PM.jpeg": 1200,
	"./WhatsApp Image 2025-01-17 at 11.44.10 PM.jpeg": 7918
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5135;